import BaseService from 'services/BaseService';
import api from '../common/constants/api';

class ExecutionReportingService extends BaseService {
  getPublishers() {
    return this.get(api.publishers);
  }

  getReports(params) {
    return this.get(api.reports, params);
  }
}

export default ExecutionReportingService;



// WEBPACK FOOTER //
// ./src/services/ExecutionReportingService.js